const DependenciesAllLanes = [
    "sentry.analysis.profile",
    "sentry.analysis.proximity",
    "sentry.analysis.network",
    "sentry.analysis.associative",
    "sentry.report.pcl.priority",
    "sentry.report.pcl.ocr",
    "sentry.report.pcl.camera.sla",
    "sentry.report.traffic.flow.point",
    "sentry.report.traffic.flow.route",
    "sentry.report.traffic.vehicle.stay",
    "sentry.passage.search.sentrycloud",
    "sentry.passage.search.georef",
    "sentry.passage.search.filter",
    "sentry.passage.search.report",
    "sentry.alarm.sign2",
    "sentry.analysis.intersection",
    "sentry.passage.export",
]

export default DependenciesAllLanes;